define('LocationShippingTimes.Shopping.EntryPoint', [
  'LocationShippingTimes.Configuration',
  'DateCalculations',
  'ShippingByLocation',
  'LocationsTable',
  'ShippingCountdown',
  'ZipCodeSelector'
], function KodellaLocationShippingTimesShopping(
  Configuration,
  DateCalculations,
  ShippingByLocation,
  LocationsTable,
  ShippingCountdown,
  ZipCodeSelector
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      Configuration.initialize(container);
      DateCalculations.mountToApp(container);
      ShippingByLocation.mountToApp(container);
      LocationsTable.mountToApp(container);
      ShippingCountdown.mountToApp(container);
      ZipCodeSelector.mountToApp(container);
    }
  };
});
